import { Control } from 'react-hook-form';

/**
 * Transform the date value and return a valid date object or undefined if parsing fails.
 * This can be used so we can invalidate wrong dates correctly.
 */
export function transformDate(value: string, originalValue: string) {
    const parsedDate = new Date(originalValue);

    return isNaN(parsedDate.getTime()) ? undefined : value;
}

/**
 * Get an array of numbers building from min to max to use for a select field.
 *
 * @param { min: number, max: number }
 * @returns { value: number, label: string }[]
 *
 * @example
 * getNumbersOptions({ min: 1, max: 2 })
 * // [{ value: 1, label: '1' }, { value: 2, label: '2' }]
 */
export function getNumbersOptions({
    min = 1,
    max = 10,
}: {
    min?: number;
    max?: number;
}) {
    return Array.from({ length: max - min + 1 }, (_, i) => ({
        value: i + min,
        label: (i + min).toString(),
    }));
}

export function asTypedControl<Type>(name: string, control?: object) {
    if (!control) return undefined;

    return control as unknown as Control<{ [name]: Type }>;
}
